import React, {useState} from "react"
import MainHeader from "../../mainComponents/Header";
import MainFooter from "mainComponents/MainFooter";
import {Heading} from "../../components";
import {useTranslation} from "react-i18next";
import MainHeaderWithBurger from "../../components/HeaderButton/headerWithBurgerMain";
import {AccordionFAQBlock} from "../../LandingComponents/Desktop/FAQ/Accordion";
import {useNavigate} from "react-router-dom";

export default function FAQPage() {
    const {t} = useTranslation();

    const navigate = useNavigate();

    const tabs = [
        {
            id: 'aboutProducts',
            title: t("FAQ.tabs.1.tabsName"),
            contentCount: 6,
            content: () => (
                <AccordionFAQBlock
                    data={[
                        {
                            question: t("FAQ.tabs.1.tabsContent.1.title"),
                            answer: t("FAQ.tabs.1.tabsContent.1.description"),
                        },
                        {
                            question: t("FAQ.tabs.1.tabsContent.2.title"),
                            answer: t("FAQ.tabs.1.tabsContent.2.description"),
                        },
                        {
                            question: t("FAQ.tabs.1.tabsContent.3.title"),
                            answer: t("FAQ.tabs.1.tabsContent.3.description"),
                        },
                        {
                            question: t("FAQ.tabs.1.tabsContent.4.title"),
                            answer: t("FAQ.tabs.1.tabsContent.4.description"),
                        },
                        {
                            question: t("FAQ.tabs.1.tabsContent.5.title"),
                            answer: t("FAQ.tabs.1.tabsContent.5.description"),
                        },
                        {
                            question: t("FAQ.tabs.1.tabsContent.6.title"),
                            answer: t("FAQ.tabs.1.tabsContent.6.description"),
                        },
                    ]}
                />
            )
        },
        {
            id: 'aboutProjects',
            title: t("FAQ.tabs.2.tabsName"),
            contentCount: 9,
            content: () => (
                <AccordionFAQBlock
                    data={[
                        {
                            question: t("FAQ.tabs.2.tabsContent.1.title"),
                            answer: t("FAQ.tabs.2.tabsContent.1.description"),
                        },
                        {
                            question: t("FAQ.tabs.2.tabsContent.2.title"),
                            answer: t("FAQ.tabs.2.tabsContent.2.description"),
                        },
                        {
                            question: t("FAQ.tabs.2.tabsContent.3.title"),
                            answer: t("FAQ.tabs.2.tabsContent.3.description"),
                        },
                        {
                            question: t("FAQ.tabs.2.tabsContent.4.title"),
                            answer: t("FAQ.tabs.2.tabsContent.4.description"),
                        },
                        {
                            question: t("FAQ.tabs.2.tabsContent.5.title"),
                            answer: t("FAQ.tabs.2.tabsContent.5.description"),
                        },
                        {
                            question: t("FAQ.tabs.2.tabsContent.6.title"),
                            answer: t("FAQ.tabs.2.tabsContent.6.description"),
                        },
                        {
                            question: t("FAQ.tabs.2.tabsContent.7.title"),
                            answer: t("FAQ.tabs.2.tabsContent.7.description"),
                        },
                        {
                            question: t("FAQ.tabs.2.tabsContent.8.title"),
                            answer: t("FAQ.tabs.2.tabsContent.8.description"),
                        },
                        {
                            question: t("FAQ.tabs.2.tabsContent.9.title"),
                            answer: t("FAQ.tabs.2.tabsContent.9.description"),
                        },
                    ]}
                />
            )
        },
        {
            id: 'aboutServices',
            title: t("FAQ.tabs.3.tabsName"),
            contentCount: 10,
            content: () => (
                <AccordionFAQBlock
                    data={[
                        {
                            question: t("FAQ.tabs.3.tabsContent.1.title"),
                            answer: t("FAQ.tabs.3.tabsContent.1.description"),
                        },
                        {
                            question: t("FAQ.tabs.3.tabsContent.2.title"),
                            answer: t("FAQ.tabs.3.tabsContent.2.description"),
                        },
                        {
                            question: t("FAQ.tabs.3.tabsContent.3.title"),
                            answer: t("FAQ.tabs.3.tabsContent.3.description"),
                        },
                        {
                            question: t("FAQ.tabs.3.tabsContent.4.title"),
                            answer: t("FAQ.tabs.3.tabsContent.4.description"),
                        },
                        {
                            question: t("FAQ.tabs.3.tabsContent.5.title"),
                            answer: t("FAQ.tabs.3.tabsContent.5.description"),
                        },
                        {
                            question: t("FAQ.tabs.3.tabsContent.6.title"),
                            answer: t("FAQ.tabs.3.tabsContent.6.description"),
                        },
                        {
                            question: t("FAQ.tabs.3.tabsContent.7.title"),
                            answer: t("FAQ.tabs.3.tabsContent.7.description"),
                        },
                        {
                            question: t("FAQ.tabs.3.tabsContent.8.title"),
                            answer: t("FAQ.tabs.3.tabsContent.8.description"),
                        },
                        {
                            question: t("FAQ.tabs.3.tabsContent.9.title"),
                            answer: t("FAQ.tabs.3.tabsContent.9.description"),
                        },
                        {
                            question: t("FAQ.tabs.3.tabsContent.10.title"),
                            answer: t("FAQ.tabs.3.tabsContent.10.description"),
                        },
                    ]}
                />
            )
        },
    ];

    const [activeTab, setActiveTab] = useState(tabs[0].id);

    const renderContent = () => {
        const tab = tabs.find(tab => tab.id === activeTab);
        return tab ? tab.content : null;
    };

    return (
        <div className={"bg-[#B0B0B0] min-h-screen  flex flex-col"}>
            <div className="md:hidden sm:hidden">
                <MainHeader/>
            </div>
            <div className="lg:hidden">
                <MainHeaderWithBurger/>
            </div>

            <div className={"lg:pb-[160px] md:pb-[100px] sm:pb-[80px] lg:pt-[100px] md:pt-[50px] sm:pt-[80px] lg:px-6 md:px-5 sm:px-4 container-xs"}>

                <div className="flex flex-row md:flex-col sm:flex-col justify-between gap-5 md:gap-[30px] sm:gap-8">

                    {/* Левая часть с табами */}
                    <div className={"w-[50%] md:w-full sm:w-full"}>
                        <Heading size={"desktop_heading_2"} className="text-[#191C30E5] whitespace-pre-wrap sm:text-[28px] sm:leading-[120%] sm:uppercase">
                            {t("FAQ.rightTitle")}
                        </Heading>
                        <ul className="mt-10 md:flex md:flex-wrap md:gap-2 sm:flex sm:flex-wrap sm:gap-1.5">
                            {tabs.map(tab => (
                                <li key={tab.id}
                                    className={" md:max-w-none sm:max-w-none"}>
                                    <button
                                        onClick={() => setActiveTab(tab.id)}
                                        className={`flex flex-row items-center text-left text-[15px] leading-6 px-3 py-[10px] rounded-md transition-colors duration-200 outline-none gap-2 ${
                                            activeTab === tab.id
                                                ? "bg-white shadow text-black border border-[#FFB800]"
                                                : "text-gray-700 hover:bg-gray-200 border border-transparent"
                                        }`}
                                    >
                                        {tab.title}
                                        <Heading
                                            size="desktop_body_xs"
                                            className="bg-[#79818C1F] text-[#191C30E5] w-5 h-5 rounded-full text-center leading-5"
                                        >
                                            {tab.contentCount}
                                        </Heading>
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Правая часть с контентом */}
                    <div className={"w-[50%] md:w-full sm:w-full"}>
                        <div>
                            {tabs.find(tab => tab.id === activeTab)?.content()}
                        </div>
                        <button
                            onClick={() => navigate("/landing")}
                            className={`bg-[#FFB800] w-[320px] h-[56px] rounded-[12px] items-center justify-center flex mt-10`}>
                            <Heading
                                size={"desktop_body_m_bold"}
                                className={`text-[#1B1F3B] uppercase`}>
                                {t("FAQ.button")}
                            </Heading>
                        </button>
                    </div>

                </div>

            </div>

            <div className={'mb-0 mt-auto'}>
                <MainFooter/>
            </div>
        </div>

    );
}